/* istanbul ignore file - better tested visually */

import { faCheckCircle, faInfoCircle, faTriangleExclamation, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '@partful/shared/lib/classNames';
import { Typography } from '@partful/shared/ui/Typography';
import { ComponentProps } from 'react';
import styles from './FormField.module.scss';

export function FormField({ className, children, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.control, className)} {...rest}>
      {children}
    </div>
  );
}

export type FormFieldMessageProps = {
  type?: 'info' | 'error' | 'success';
  show?: boolean;
};

export function FormFieldMessage({
  type = 'error',
  show = true,
  className,
  children,
  ...rest
}: ComponentProps<'label'> & FormFieldMessageProps) {
  if (!show) return null;

  let icon: IconDefinition;
  switch (type) {
    case 'info': {
      icon = faInfoCircle;
      break;
    }
    case 'success': {
      icon = faCheckCircle;
      break;
    }
    case 'error':
    default: {
      icon = faTriangleExclamation;
      break;
    }
  }

  return (
    <Typography as="label" appearance="label" className={classNames(styles.message, styles[type], className)} {...rest}>
      <FontAwesomeIcon icon={icon} /> {children}
    </Typography>
  );
}

export function FormFieldLabel({ className, children, ...rest }: ComponentProps<'label'>) {
  return (
    <Typography as="label" className={classNames(styles.label, className)} {...rest}>
      {children}
    </Typography>
  );
}
